import React, { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import { FaCheckCircle, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { IoIosRadioButtonOff } from "react-icons/io";
import { IoRadioButtonOnOutline } from "react-icons/io5";
import BorderlessButton from "components/Button/BorderlessButton";
import { useAppContext } from "contexts/AppContext";
import NodeHelper from "helpers/NodeHelper";
import Utils from "Services/Utils";
import * as consts from "constants/constants";
import { TUI_BuilderPage } from "types";
import { isArray } from "lodash";
import usePages from "hooks/usePages";

export default function LinearPagesGeneric() {
    const {
        activePage,
        setPage,
        getInstances,
        builderSpec,
        specs,
        modelSpec,
    } = useAppContext();


    const {
        newPages,
        scrollIndicator,
        pagesNavRef,
        pageGroups,
        selectPrev,
        selectNext,
        startDragging,
        stopDragging,
        move,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
        lastPage,
        isLinear,
        firstPage
    } = usePages()

    let currentIndex = useRef<number|null>(null)

    if (Object.entries(pageGroups).length === 0) return <></>;

    return (
        <div className="sb3-bg-blue-500" style={{backgroundColor: builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}}>
                    <div className="sb3-max-w-7xl sb3-m-auto sb3-pt-4 sb3-space-y-2">
                        <h2 className="sb3-text-white sb3-block  sb3-px-9 sm:sb3-hidden">{modelSpec?.[consts.DEFN_PROJECT].ISRName}</h2>
                        <div className="sb3-relative sb3-max-w-full">
                            <div 
                                ref={pagesNavRef}
                                className={`
                                    submodelNav sb3-max-w-full sb3-flex sb3-items-center sb3-overflow-x-auto sb3-overflow-y-hidden sb3-py-2 sb3-cursor-grab sb3-select-none sb3-relative sb3-w-min sb3-m-auto
                                    ${Object.entries(pageGroups).length > 1 ? "sb3-pt-5" :"sb3-pt-2"}
                                    `}
                                style={{
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}
                                onMouseDown={startDragging}
                                onMouseLeave={stopDragging}
                                onMouseUp={stopDragging}
                                onMouseMove={move}
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                                onTouchEnd={handleTouchEnd}
                            >
                                {
                                    Object.entries(pageGroups).map(([groupName, pages], index) => {
                                        return  <React.Fragment key={index}>
                                        <div 
                                        className="sb3-space-y-2" 
                                        >
                                            <div className={`sb3-flex sb3-items-center  ${(isArray(pages) && pages?.length > 0) && 'sb3-last:pr-1'}`}>
                                                {
                                                pages?.map((page, key) => {
                                                    if(activePage?.[consts.PAGE_ID] === page[consts.PAGE_ID]) currentIndex.current = newPages.findIndex(_page => _page[consts.PAGE_ID] === activePage?.[consts.PAGE_ID])
                                                    // check if any of the submodel is required 
                                                    const isRequired = page[consts.PAGE_FORM_DATA].some((builderSubmodel) => {
                                                        const modelSubmodel = specs[builderSubmodel[consts.FRMDATA_SMID]]
                                                        if(!modelSubmodel) return false
                                    
                                                        const instances = getInstances(builderSubmodel[consts.FRMDATA_SMID])
                                                        if(instances?.length === 0) return false
                                    
                                                        return instances?.some(instance => NodeHelper.checkIfSubmodelIsRequiredByRuntimeSpec(
                                                            instance
                                                        ))
                                                    })
                                    
                                                    const isDone = page[consts.PAGE_FORM_DATA].every((builderSubmodel) => {
                                                        const modelSubmodel = specs[builderSubmodel[consts.FRMDATA_SMID]]
                                                        if(!modelSubmodel) return false
                                    
                                                        const instances = getInstances(builderSubmodel[consts.FRMDATA_SMID])
                                                        if(instances?.length === 0) return false
                                    
                                                        return instances?.some(instance => NodeHelper.checkIfSubmodelIsDoneByRuntimeSpec(
                                                            instance, 
                                                            page[consts.PAGE_LAYOUT]
                                                        ))
                                                    })

                                                    const isFirstPage = firstPage[consts.PAGE_ID] === page[consts.PAGE_ID]
                                                    const isLastPage = lastPage[consts.PAGE_ID] === page[consts.PAGE_ID]

                                                    return (
                                                        <Fragment key={key}>
                                                            <div 
                                                                id={`step-submodel-${page?.[consts.PAGE_ID]}`}
                                                                className={`page-name`}>
                                                                    <BorderlessButton 
                                                                        active={activePage?.[consts.PAGE_ID] === page[consts.PAGE_ID]}
                                                                        onClick={() => !isLinear 
                                                                            && setPage(page[consts.PAGE_ID])}
                                                                        className={`sb3-flex sb3-flex-col sb3-items-center !sb3-border-0 sb3-w-max sb3-rounded-none sb3-font-semibold hover:!sb3-text-white sb3-relative !sb3-text-white sb3-z-10  sb3-min-w-min !sb3-py-0 !sb3-px-2 sb3-space-y-2
                                                                            ${isLinear && "!sb3-cursor-default"}
                                                                            ${
                                                                                !isFirstPage && 
                                                                                `before:sb3-content-[''] before:sb3-h-0.5 before:sb3-w-1/2 
                                                                                before:sb3-bg-white before:sb3-inline-block before:sb3-absolute 
                                                                                before:sb3-right-1/2 before:sb3-top-2 before:-sb3-z-10`
                                                                            }
                                                                            ${
                                                                                !isLastPage && 
                                                                                `after:sb3-content-[''] after:sb3-h-0.5 after:sb3-w-1/2 
                                                                                after:sb3-bg-white after:sb3-inline-block after:sb3-absolute 
                                                                                after:sb3-left-1/2 after:sb3-top-2 after:-sb3-z-10`
                                                                            }
                                                                        `}
                                                                        >
                                                                        { 
                                                                            isDone ? <FaCheckCircle 
                                                                            className={`sb3-text-white sb3-text-xl sb3-bg-inherit sb3-bg-blue-500`}
                                                                            style={{backgroundColor: builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}}
                                                                            />
                                                                            :
                                                                            activePage?.[consts.PAGE_ID] === page[consts.PAGE_ID] ? 
                                                                                <IoRadioButtonOnOutline className="sb3-text-white sb3-text-xl sb3-bg-blue-500"
                                                                                    style={{backgroundColor: builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}}
                                                                                /> :
                                                                                <IoIosRadioButtonOff className="sb3-text-white sb3-text-xl sb3-bg-blue-500"
                                                                                    style={{backgroundColor: builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}}
                                                                                />
                                                                        }
                                                                        <span className="sb3-text-base sb3-font-semibold hover:!sb3-text-white !sb3-text-white sb3-min-w-[170px] sb3-p-3">
                                                                            {
                                                                                page[consts.PAGE_NAME]} {(isRequired && !isDone) ? 
                                                                                    <span className="sb3-text-red-500">*</span> : 
                                                                                    ""
                                                                            }
                                                                        </span>
                                                                        { isFirstPage && Object.entries(pageGroups).length > 1 && <span className="sb3-absolute -sb3-top-8 sb3-text-sm sb3-text-gray">{groupName}</span> }
                                                                    </BorderlessButton>
                                                            </div>
                                                        </Fragment>
                                                    )
                                                })}
                                            </div>


                                        </div>
                                        </React.Fragment>
                                    })
                                }
                                
                            </div>
                            {
                            Utils.checkOverflow(pagesNavRef.current) && (scrollIndicator.left) && 
                            (
                                <div className="sb3-absolute  sb3-left-0 sb3-z-[1000] sb3-top-0 sb3-h-full sb3-flex sb3-items-center"
                                    style={{background: builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}}
                                >
                                    <span className="sb3-absolute sb3-left-full sb3-w-20 sb3-h-full sb3-pointer-events-none" 
                                    style = {{backgroundImage: `linear-gradient(to right, ${builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}, rgba(255, 255, 255, 0))`}}
                                    />
                                    <button type="button" className="-sb3-mt-14 sb3-ml-3 sb3-text-black sb3-z-10 sb3-bg-light sb3-p-1.5  focus:!sb3-outline-none" onClick={selectPrev}>
                                        <FaChevronLeft />
                                    </button>
                                </div>
                            )}
                            {Utils.checkOverflow(pagesNavRef.current) && (scrollIndicator.right) && (
                                <div className="sb3-absolute sb3-right-0 sb3-z-[1000] sb3-top-0 sb3-h-full sb3-flex sb3-items-center"
                                    style={{background: builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]}}
                                >
                                    <span className="sb3-absolute sb3-right-full sb3-w-20 sb3-h-full sb3-pointer-events-none" 
                                        style = {{backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0), ${builderSpec?.[consts.BUILDER_CONFIG]?.[consts.CONFIG_CUSTOMIZATION]?.[consts.CUSTOMIZATION_THEME_SETTINGS]?.[consts.THEME_PRIMARY_COLOR]})`}}
                                    />
                                    <button type="button" className="-sb3-mt-14 sb3-text-black sb3-mr-3 sb3-z-10 sb3-bg-light sb3-p-1.5  focus:!sb3-outline-none" onClick={selectNext}>
                                        <FaChevronRight />
                                    </button>
                                </div>
                            )}
                        </div>
                </div>
        </div>
    );
}